/** Иконки управления просмотрщиком историй (обобщённые, наследуют currentColor). */

export const PauseIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <rect x="6" y="5" width="4" height="14" rx="1" />
    <rect x="14" y="5" width="4" height="14" rx="1" />
  </svg>
)

export const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M7 5v14l12-7z" />
  </svg>
)

export const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
)

/** Шеврон в кружке — переход между слайдами. */
export const ChevronIcon = ({ dir }: { dir: 'left' | 'right' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    {dir === 'left' ? <path d="M15 5l-7 7 7 7" /> : <path d="M9 5l7 7-7 7" />}
  </svg>
)

/** Замок — заглушка платной истории без подписки. Точный SVG из макета. */
export const LockIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" aria-hidden>
    <path
      d="M50 24H48V16.367C48 7.189 41.359 0 31.926 0C22.455 0 16 7.342 16 16.367V24H14C9.588 24 6 27.588 6 32V56C6 60.412 9.588 64 14 64H50C54.412 64 58 60.412 58 56V32C58 27.588 54.412 24 50 24ZM20 16.367C20 9.549 24.66 4 31.926 4C39.117 4 44 9.432 44 16.367V24H20V16.367ZM54.0001 56C54.0001 58.205 52.2051 60 50.0001 60H14.0001C11.7951 60 10.0001 58.205 10.0001 56V32C10.0001 29.795 11.7951 28 14.0001 28H50.0001C52.2051 28 54.0001 29.795 54.0001 32V56ZM32.0001 36C29.7911 36 28.0001 37.791 28.0001 40C28.0001 41.477 28.8101 42.752 30.0001 43.445V50C30.0001 51.104 30.8961 52 32.0001 52C33.1041 52 34.0001 51.104 34.0001 50V43.445C35.1901 42.752 36.0001 41.476 36.0001 40C36.0001 37.791 34.2091 36 32.0001 36Z"
      fill="currentColor"
    />
  </svg>
)

/** Скип (play-треугольник + палка) — перескок между историями. Точный SVG из макета. */
export const SkipIcon = ({ dir }: { dir: 'left' | 'right' }) => (
  <svg viewBox="0 0 36 36" fill="none" aria-hidden>
    <g transform={dir === 'right' ? 'translate(36,0) scale(-1,1)' : undefined}>
      <path
        d="M11.01 14.0295C8.3295 15.7605 8.3295 20.2395 11.01 21.9705L27.195 32.421C29.7975 34.1055 33 31.9155 33 28.452V7.54947C33 4.08447 29.799 1.89597 27.195 3.57747L11.01 14.0295Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M3 7.5V28.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </g>
  </svg>
)
